/* global $: true */
'use strict';

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('eventRegistrationForm');
  var contactForms = document.querySelectorAll('.epc-contact-form');
  var carousels = document.querySelectorAll('.owl-carousel');
  var sideNav = document.querySelector('.nav-tabs-three');

  if (typeof $.fn.owlCarousel === 'function' ) {
    $('.four-items-slider').owlCarousel({ items: 4, autoPlay: true, slideSpeed: 100 });
  }

  const noPostalCountries = ['angola', 'antigua and barbuda', 'aruba', 'bahamas', 'belize', 'benin', 'botswana', 'burkina faso', 'burundi', 'cameroon', 'central african republic', 'comoros', 'congo', 'congo, the democratic republic of the', 'cook islands', 'cote d\'ivoire', 'djibouti', 'dominica', 'equatorial guinea', 'eritrea', 'fiji', 'french southern territories', 'gambia', 'ghana', 'grenada', 'guinea', 'guyana', 'hong kong', 'ireland', 'jamaica', 'kenya', 'kiribati', 'macao', 'malawi', 'mali', 'mauritania', 'mauritius', 'montserrat', 'nauru', 'netherlands antilles', 'niue', 'north korea', 'panama', 'qatar', 'rwanda', 'saint kitts and nevis', 'saint lucia', 'sao tome and principe', 'saudi arabia', 'seychelles', 'sierra leone', 'solomon islands', 'somalia', 'south africa', 'suriname', 'syria', 'tanzania, united republic of', 'timor-leste', 'tokelau', 'tonga', 'trinidad and tobago', 'tuvalu', 'uganda', 'united arab emirates', 'vanuatu', 'yemen', 'zimbabwe'];
  const euCountries = ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden', 'United Kingdom'];
  const MEVATCountries = ['Bahrain', 'Kuwait', 'Oman', 'Qatar', 'Saudi Arabia', 'United Arab Emirates'];
  var EPCEvent = {
    firstStep: $(form).find('section[data-step="sup"]'),
    steps: [],
    stepDescription: {
      sup: {
        en: 'Choose your rate',
        ru: 'выбор тарифа'
      },
      prod: {
        en: 'Choose your rate',
        ru: 'выбор тарифа'
      },
      delegate: {
        en: 'Delegate details',
        ru: 'информация о делегате'
      },
      invoice: {
        en: 'Invoice details',
        ru: 'информация для инвойса'
      },
      summary: {
        en: 'Summary',
        ru: 'сводка'
      }
    },
    formData: {
      contacts: [],
      company: {},
      invoice: {
        currency: 'GBP',
        original_rate_currency: 'GBP'
      }
    },
    rates: [],
    invoiceProcessed: false,
    contactIndex: 0
  };

  if (form) {
    $('section[data-step="type"] button').each(function(i, btn) {
      $(btn).click(function() {
        var container = $(this).closest('section');
        var stepName = $(this).attr('id').split('-')[0];
        goToStep(container, stepName);
        $(container).remove();
      });
    });

    $('input[name="rates"]').each(function() {
      $(this).change(function() {
        if (this.type === 'radio') {
          $(this).closest('section').find('button').prop('disabled', false);
        }
        // ТУТ МОЖНО СКАЛЬКУЛИРОВАТЬ ИТОГ в EPCEvent.amount
      });
    });

    $('.btn-move').each(function() {
      $(this).click(function(evt) {
        evt.preventDefault();
        var nextStepName = $(this).data('go');
        var container = $(this).closest('section');
        var thisStepName = $(container).data('step');
        if ( $.inArray(thisStepName, EPCEvent.steps) === -1) {
          EPCEvent.steps.push(thisStepName);
        }

        if (nextStepName === 'summary') {
          if ( stepIsValid(container) ) {
            serialize();
            renderReport();
            // if (EPCEvent.formData.invoice.merchant === 'payfort') {
            //   $(form).find('.checkout-btn[data-processing="payfort"]').addClass('selected');
            //   $(form).find('.checkout-btn[data-processing="normal"]').removeClass('selected');
            // } else {
            //   $(form).find('.checkout-btn[data-processing="normal"]').addClass('selected');
            //   $(form).find('.checkout-btn[data-processing="payfort"]').removeClass('selected');
            // }
          }
        }
        if (thisStepName === 'summary' && nextStepName === 'checkout') {
          if ( stepIsValid(container) ) {
            if ( $(evt.currentTarget).data('wallet') ) {
              EPCEvent.formData.invoice.digital_wallet = $(evt.currentTarget).data('wallet');
            }
            submitRegistration();
            $(container).find('button[data-go="oneMore"]').hide();
            $(container).find('button[data-go="previous"]').hide();
            return;
          }
        }
        if (nextStepName === 'previous') {
          var thisIndex = $.inArray(thisStepName, EPCEvent.steps);
          goToStep(container, EPCEvent.steps[thisIndex - 1]);
        } else if (nextStepName === 'oneMore') {
          EPCEvent.contactIndex++;
          invoiceProcessed();
          cleanInputs();
          goToStep(container, EPCEvent.steps[0]);
        } else {
          // костыль для опциональной валидации coordinator email
          let coordinatorValid = 1;
          if (thisStepName === 'delegate' && document.getElementById('coordinator__email').value !== '') {
            coordinatorValid = _validateInput(document.getElementById('coordinator__email'));
          }
          if ( stepIsValid(container) && coordinatorValid === 1) {
            goToStep(container, nextStepName);
          }
        }
      });
    });
    addListeneres();
  }

  if (contactForms && contactForms.length > 0) {
    [].forEach.call(contactForms, contactForm => {
      var mail = {
        subject: 'Form at ' + document.getElementById('event__short_title').textContent + ' page has been submitted',
        url: window.location.href
      };
      if (contactForm.dataset.type) {
        let formType = contactForm.dataset.type.replace(/-/g, ' ');
        formType = formType.charAt(0).toUpperCase() + formType.slice(1);
        mail.subject = formType + ' form at ' + document.getElementById('event__short_title').textContent + ' page has been submitted';
      }
      [].forEach.call(contactForm.querySelectorAll('input[required]'), element => {
        $(element).blur( evt => {
          _validateInput(evt.target);
        });
      });
      var submitBtn = contactForm.querySelector('.btn-epc-form-submit') || contactForm.querySelector('.btn-primary');
      if (submitBtn === null) {
        submitBtn = document.querySelector('.btn-epc-form-submit');
      }
      submitBtn.addEventListener('click', evt => {
        evt.preventDefault();
        if (stepIsValid(contactForm) && beforeSubmit(evt, contactForm)) {
          evt.target.disabled = true;
          appendSpinner(submitBtn);
          var contactFormEventIDElement = document.querySelector('#contact_from_event_id');
          if (contactFormEventIDElement) {
            mail.event_id = contactFormEventIDElement.textContent;
          }
          // Корректная обработка recipients
          var mailBodyParamsArray = [];
          $(contactForm).serializeArray().forEach(el => {
            if (el.name === 'recipients') {
              mail.recipients = el.value;
            } else {
              mailBodyParamsArray.push(el.name + ': ' + el.value);
            }
          });
          mail.body = mailBodyParamsArray.join('<br/>\n');
          mail.body += '\n\n<br/><br/>Form url: ' + mail.url;
          $.ajax({
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            url: '/contact_form',
            dataType: 'json',
            data: JSON.stringify(mail),
            success: function() {
              showConfirmationBlock(contactForm, 'success');
              if (submitBtn.firstChild.classList.contains('fa-spinner')) {
                submitBtn.firstChild.classList.remove('fa-spinner', 'fa-spin', 'fa-fw');
                submitBtn.firstChild.classList.add('fa-check');
              }
            },
            error: function() {
              console.error('Contact form failed: ', mail);
              showConfirmationBlock(contactForm, 'error');
            },
            complete: function(data) {
              afterSubmit({
                target: {
                  status: data.status,
                  response: data.responseText
                }
              }, contactForm);
            }
          });
        }
      });

    });
  }

  if (carousels && carousels.length > 0 ) {
    [].forEach.call(carousels, element => {
      $(element).owlCarousel({
        navigation: false,
        slideSpeed: 300,
        paginationSpeed: 400,
        singleItem: true
      });
    });
  }

  if (sideNav) {
    [].forEach.call(sideNav.querySelectorAll('a'), el => {
      if ( (el.textContent.match(/Register Now/) || el.textContent.match(/Форма регистрации/)) && el.parentNode.className !== 'active') {
        $(el).addClass('register-now');
      }
    });
  }

  function stepIsValid(container) {
    var validInputs = [];
    $(container).find('input[required]').each(function(i, element) {
      validInputs.push( _validateInput(element) );
    });
    if (validInputs.indexOf(0) === -1) {
      return true;
    } else {
      return false;
    }
  }

  function goToStep(thisContainer, stepName) {
    $(thisContainer).css('display', 'none');
    $(form).find('section[data-step="' + stepName + '"]').css('display', 'block');
    var lang = window.location.hostname.match(/\.ru/) ? 'ru' : 'en';
    $('.page-title-extended').text(': ' + EPCEvent.stepDescription[stepName][lang]);
  }

  function cleanInputs() {
    $(form).find('section:first-child input').each(function(i, el) {
      $(el).prop('checked', false);
    });
    $(form).find('section:first-child button').prop('disabled', true);
    $(form).find('section[data-step="delegate"] input').each(function(i, el) {
      $(el).val('');
      if (el.parentNode.className.match('form-group')) {
        el.parentNode.className = el.parentNode.className.replace(/has-success/g, '').replace(/has-error/g, '');
      }
    });
  }

  function invoiceProcessed() {
    EPCEvent.invoiceProcessed = true;
    $('section[data-step="delegate"]').find('button[data-go="invoice"]').data('go', 'summary');
    $('section[data-step="summary"]').find('button[data-go="previous"]').data('go', 'delegate');
  }



  function renderReport() {
    renderPaymentReport();
    renderInvoiceReport();
    [].forEach.call(document.querySelectorAll('#summary-delegates td'), td => {
      td.parentNode.removeChild(td);
    });
    $(EPCEvent.formData.contacts).each(function(i, c) {
      renderContactReport(i, c);
    });
  }

  function renderContactReport(index, contact) {
    [].forEach.call(document.querySelectorAll('#summary-delegates th'), element => {
      let property = element.textContent.replace(/\s+/, '').toLowerCase();
      let td = document.createElement('td');
      td.textContent = contact[property] || '';
      element.parentNode.appendChild(td);
    });
    // jQuery version
    // $('#summary-delegates').find('th').each(function() {
    //   let element = $(this);
    //   let property = $(element).text().toLowerCase();
    //   let td = document.createElement('td');
    //   td.textContent = contact[property] || '';
    //   $(element).parent().append(td);
    // });
  }

  function renderPaymentReport() {
    var table = document.getElementById('summary-payments');
    $(table).find('tbody').empty();
    var subtotalSpan = document.getElementById('summary-payments-total');
    var subtotal = 0;
    var num = 1;
    EPCEvent.formData.invoice.original_rate_currency = $(EPCEvent.firstStep).find('input.rate:checked').first().data('currency');

    EPCEvent.formData.contacts.forEach(contact => {
      contact.rates.forEach(r => {
        var rateElement = $(form).find('.rate[value="' + r + '"]').first();
        var amount = parseFloat($(rateElement).data('amount'));
        EPCEvent.formData.invoice.original_rate_currency = $(rateElement).data('currency');
        var tr = document.createElement('tr');
        subtotal += amount;
        tr.innerHTML = '<td>' + num + '</td><td>' + $(rateElement).data('text') + '</td><td>' + amount + '</td>';
        table.querySelector('tbody').appendChild(tr);
        num++;
      });
    });
    $('.summary-payments-currency').each(function(i, el) {
      el.textContent = EPCEvent.formData.invoice.original_rate_currency;
    });

    // VAT processing
    if ($('input[name="form_tax"]') && $('input[name="form_tax"]').val() !== '0') {
      var vatAmount = parseFloat( (subtotal * ( parseFloat($('input[name="form_tax"]').val()) / 100)).toFixed(2) );
      var subtotalNetSpan = document.getElementById('summary-payments-totalnet');
      var VatSpan = document.getElementById('summary-payments-vat');
      if (VatSpan && subtotalNetSpan) {
        VatSpan.parentNode.style.display = 'table-row';
        VatSpan.textContent = vatAmount;
        subtotalNetSpan.parentNode.style.display = 'table-row';
        subtotalNetSpan.textContent = subtotal;
        subtotalSpan.textContent = (subtotal + vatAmount).toFixed(2);
      }
    } else {
      subtotalSpan.textContent = subtotal;
    }

  }

  function renderInvoiceReport() {
    var invoiceReportElement = $('section[data-step="summary"] article').first();
    $(invoiceReportElement).find('dd').each(function() {
      $(this).empty();
    });
    ['company', 'address', 'vatnumber', 'method', 'ref_po'].forEach(dd => {
      let element = $(invoiceReportElement).find('#dd-' + dd);
      if (dd === 'method') {
        let explainedMethod = EPCEvent.formData.invoice.method === 'CC' ? 'Credit card payment' : 'Bank transfer';
        $(element).text(explainedMethod + ' in ' + EPCEvent.formData.invoice.currency);
      } else {
        $(element).text(EPCEvent.formData.invoice[dd]);
      }
    });
  }

  function addListeneres() {
    var copyDelegatesBtn = document.getElementById('copy-delegates');
    if (copyDelegatesBtn) {
      copyDelegatesBtn.addEventListener('click', copyAddress);
    }

    var registrationForm = document.getElementById('eventRegistrationForm');
    if (registrationForm) {
      [].forEach.call(registrationForm.querySelectorAll('input[required]'), element => {
        $(element).blur( evt => {
          _validateInput(evt.target);
        });
      });
    }

    $(form).find('select').each(function(i, el) {
      if (el.id.match(/.+_country/)) {
        $(el).change(function() {
          if ($.inArray(el.value.toLowerCase(), noPostalCountries) !== -1) {
            disablePostcode($(this).closest('section'));
          } else {
            enablePostcode($(this).closest('section'));
          }
          checkCountryForVAT(el);
        });
      }
    });
  }

  // VAT Number should be filled in for EU countries and for some ME countries (MEVATCountries)
  function checkCountryForVAT(el) {
    var country = el.value;
    var vatCountries = euCountries.concat(MEVATCountries);
    if (el.id === 'invoice_country' && $.inArray(country, vatCountries) !== -1) {
      enableVATNumber();
    } else {
      disableVATNumber();
    }
  }


  function _validateInput(input) {
    var formGroupElement = input.parentNode;
    // Обработка input[type="checkbox"], т.к. они вложены в другие теги
    if (input.type === 'checkbox') {
      formGroupElement = input.parentNode.tagName === 'label' ?
        input.parentNode.parentNode.parentNode.parentNode :
        input.parentNode.parentNode.parentNode;
    }
    if (formGroupElement.className.match('form-group')) {
      if (!$(input).callProp('checkValidity')) {
        formGroupElement.className = formGroupElement.className.replace(/has-success/g, '');
        if (!formGroupElement.className.match('has-error')) {
          formGroupElement.className += ' has-error';
        }
        return 0;
      } else {
        formGroupElement.className = formGroupElement.className.replace(/has-error/g, '');
        if (!formGroupElement.className.match('has-success')) {
          formGroupElement.className += ' has-success';
        }
        return 1;
      }
    }
    return 1;
  }

  function disablePostcode(container) {
    $(['#delegate_postcode', '#invoice_postcode']).each(function(i, el) {
      $(container).find(el).removeAttr('required').val('').parent().hide();
    });
  }

  function enablePostcode(container) {
    $(['#delegate_postcode', '#invoice_postcode']).each(function(i, el) {
      $(container).find(el).prop('required', true).parent().show();
    });
  }

  function disableVATNumber() {
    var vatEl = document.getElementById('payment_vat');
    $(vatEl).removeAttr('required').val('').parent().hide();
  }

  function enableVATNumber() {
    var vatEl = document.getElementById('payment_vat');
    $(vatEl).prop('required', true).parent().show();
  }


  function copyAddress() {
    var delegateFields = ['company', 'email', 'country', 'town', 'postcode', 'address1', 'address2'];
    delegateFields.forEach(function(field) {
      var delegateField = document.querySelector('#delegate_' + field);
      if (delegateField) {
        var invoiceField = document.querySelector('#invoice_' + field);
        if (invoiceField) {
          invoiceField.value = delegateField.value;
          if (field === 'country') {
            $(invoiceField).trigger('change');
          }
        }
      }
    });
  }


  function serialize() {
    let invoiceValues = {};
    let contact = {
      rates: []
    };
    let coordinator = 'Coordinator Details:\n';

    $(form).serializeArray().forEach(function(f) {
      if (f.value === '') {
        return;
      }
      if (f.name === 'rates') {
        contact.rates.push(f.value);
      } else if (f.name.match(/^contact__/)) {
        let property = f.name.split('__')[1];
        contact[property] = f.value;
      } else if (f.name.match(/^company__/)) {
        if (EPCEvent.invoiceProcessed === false) {
          EPCEvent.formData.company.name = f.value.toUpperCase();
        }
        contact.company = f.value.toUpperCase();
      } else if (f.name.match(/^invoice__/) && EPCEvent.invoiceProcessed === false) {
        let property = f.name.split('__')[1];
        invoiceValues[property] = f.value;
      } else if (f.name === 'payment') {
        [EPCEvent.formData.invoice.method, EPCEvent.formData.invoice.source, EPCEvent.formData.invoice.currency, EPCEvent.formData.invoice.merchant] = f.value.split(':');
        if (EPCEvent.formData.invoice.method === 'CC') {
          if (typeof EPCEvent.formData.invoice.merchant !== 'undefined') {
            EPCEvent.formData.invoice.merchant = EPCEvent.formData.invoice.merchant.toLowerCase();
          } else {
            console.error('Payment method set to "CC", but merchant is undefined');
          }
        }
        //TODO: merchant processing
      } else if (f.name.match(/^coordinator__/)) {
        let property = f.name.split('__')[1];
        coordinator += '\t' + property + ': ' + f.value + '\n';
      } else {
      //  var labelText = document.querySelector('label[for="' + f.name + '"]').textContent;
      //  formData.contact.notes = formData.contact.notes + labelText + ': ' + f.value + '\n';
      }
    });
    EPCEvent.formData.contacts[EPCEvent.contactIndex] = contact;

    if (EPCEvent.invoiceProcessed === false) {
      parseInvoiceAddress(invoiceValues, EPCEvent.formData);
    }
    EPCEvent.formData.invoice.delegates = EPCEvent.formData.contacts.length;
    if (coordinator !== 'Coordinator Details:\n') {
      EPCEvent.formData.invoice.notes = coordinator;
      if (typeof EPCEvent.formData.invoice.mail !== 'undefined' && document.getElementById('coordinator__email').value !== '') {
        EPCEvent.formData.invoice.mail.coordinator = document.getElementById('coordinator__email').value;
      }
    }
  }

  // 2019-02-06: Company name should be UPPER CASE
  function preProcess(data) {
    data.company.name = data.company.name.toUpperCase();
    data.invoice.company = data.invoice.company.toUpperCase();
    data.contacts.forEach(c => {
      c.company = c.company.toUpperCase();
    });
  }

  function submitRegistration() {
    var checkoutBtn = document.querySelector('.checkout-btn.selected');
    if (checkoutBtn) {
      checkoutBtn.disabled = 'true';
      appendSpinner(checkoutBtn);
    }

    if (_validate(EPCEvent.formData)) {
      preProcess(EPCEvent.formData);
      $.ajax({
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        url: '/event/register',
        dataType: 'json',
        data: JSON.stringify(EPCEvent.formData),
        success: function(data) {
          if (EPCEvent.formData.invoice.method === 'CC') {
            if (data.hasOwnProperty('url')) {
              var newForm = document.createElement('form');
              newForm.action = data.url;
              delete data.url;
              newForm.method = 'POST';
              Object.keys(data).forEach(k => {
                let el = document.createElement('input');
                el.type = 'hidden';
                el.name = k;
                el.value = data[k];
                newForm.appendChild(el);
              });
              document.body.appendChild(newForm);
              newForm.submit();
            } else {
              console.log('URL for merchant form is missing in server response');
            }
          } else {
            form.style.display = 'none';
            document.getElementById('registration-successfull').style.display = 'block';
          }
          var subHeader = document.querySelector('.block-heading-two');
          if (subHeader) {
            subHeader.style.display = 'none';
          }
        },
        error: function() {
          console.error('Failed registration: ', EPCEvent);
          form.style.display = 'none';
          document.getElementById('registration-failed').style.display = 'block';
          var subHeader = document.querySelector('.block-heading-two');
          if (subHeader) {
            subHeader.style.display = 'none';
          }
        }
      });
    }
  }

  function parseInvoiceAddress(invoiceValues, formData) {
    //todo переделать эту ф-цию
    let parsed = {
      company: invoiceValues.company || formData.company.name,
      index: invoiceValues.index || '',
      country: invoiceValues.country || formData.contact.country,
      city: invoiceValues.city || formData.contact.city,
      street: invoiceValues.address1 || formData.contact.address1
    };

    if (invoiceValues.mail === '1') {
      formData.invoice.mail = {
        page: invoiceValues.page,
        lang: invoiceValues.lang,
        event_id: invoiceValues.event,
        pdf: invoiceValues.invoiceSend
      };
    }

    if (invoiceValues.address2) {
      parsed.street = parsed.street + '\n' + invoiceValues.address2;
    } else {
      parsed.street = parsed.street;
    }

    var line2 = [parsed.index, parsed.city].join(' ');

    formData.invoice.type = invoiceValues.invoiceType;
    formData.invoice.tax = invoiceValues.tax;
    formData.invoice.vatnumber = invoiceValues.vatnumber;
    formData.invoice.ref_po = invoiceValues.ref_po;
    formData.invoice.company = parsed.company;
    formData.invoice.address = [parsed.street, line2, parsed.country].join('\n');
  }

  function _validate(formData) {
    if (typeof formData.company.name !== 'undefined') {
      return true;
    } else {
      console.log('Missing company');
      return false;
    }
  }

  function appendSpinner(element) {
    if (element) {
      var spinner = document.createElement('i');
      spinner.className = 'fa fa-spinner fa-spin fa-fw';
      spinner.setAttribute('style', 'margin-right: 5px');
      element.insertBefore(spinner, element.firstChild);
    }
  }

  function showConfirmationBlock(formElement, type) {
    var confirmationBlock = formElement.parentNode.querySelector('.epc-form-' + type) || document.getElementById('form-success');
    if (confirmationBlock) {
      confirmationBlock.style.display = 'block';
      formElement.parentNode.removeChild(formElement);
    }
  }

  function beforeSubmit(evt, contactForm) {
    if (typeof window.EPCConfig !== 'undefined' && typeof window.EPCConfig.beforeContactFormSubmit === 'function') {
      return window.EPCConfig.beforeContactFormSubmit(evt, contactForm) ? true : false;
    } else {
      return true;
    }
  }

  function afterSubmit(evt, contactForm) {
    if (typeof window.EPCConfig !== 'undefined' && typeof window.EPCConfig.afterContactFormSubmit === 'function') {
      return window.EPCConfig.afterContactFormSubmit(evt, contactForm) ? true : false;
    } else {
      return true;
    }
  }


  $(function() {
    $('[data-toggle="tooltip"]').tooltip();
  });

  window.EPCEvent = EPCEvent;
});
